import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { options, usingEmulators } from './config';

export { usingEmulators } from './config';
export const app = initializeApp(options);

// App Check (§15): cada crida a les Functions porta un testimoni que demostra que ve d'aquesta app.
// Només a la part que fa servir el SDK (gestió, compte, consultes): la part pública llegeix sense SDK.
// Sense clau (o amb l'emulador), no s'activa; el servidor decideix si l'exigeix (functions/src/options.ts).
const siteKey = import.meta.env.VITE_APPCHECK_SITE_KEY;
if (siteKey && !usingEmulators) {
  initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(siteKey), isTokenAutoRefreshEnabled: true });
}
